/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { saveRegistration, calculateRating, saveSurvey, registerAccount, updateAccount, updateMissingInfo, submitContact, confirmRating, selectMyUtr, validateInviteToken, declineInviteToken, verifyMagicLink } from '../api';
import { getApiErrorMessage } from '../utils/apiError';
import { getProxyAxiosInstance } from '../utils/network';
import { getActiveLeagueTeams } from './leagues-actions';
import { userIsPaidHitter } from '../utils/user';
import { getClub, getClubPaymentAccounts } from '../api/clubsApi';
import { showErrorPopup } from './notification-actions';
import { AUTH_CLEAR_ERROR, AUTH_MAGIC_LINK_SET_CALLBACK_URL } from './actionTypes/auth-action-types';

export const FETCH_FOOS = 'fetch_foos';
export const FETCH_AUTHENTICATED_USER = 'fetch_authenticated_user';
export const SAVE_ONBOARDING_STEP = 'save_onboarding_step';
export const SAVE_ONBOARDING_SUCCESS = 'save_onboarding_success';
export const SAVE_ONBOARDING_FAILED = 'save_onboarding_failed';
export const AUTHENTICATING_USER = 'authenticating_user';
export const AUTHENTICATION_FAILED = 'authenticating_failed';
export const AUTHENTICATION_FAILED_SILENT = 'authenticating_failed_silent';
export const CONFIRM_EMAIL_ACCEPTED = 'confirm_email_accepted';
export const FETCH_PAID_HIT_CLUB_SUCCESS = 'AUTH:FETCH_PAID_HIT_CLUB_SUCCESS';
export const FETCH_PAID_HIT_CLUB_PAYMENT_ACCOUNTS_SUCCESS = 'AUTH:FETCH_PAID_HIT_CLUB_PAYMENT_ACCOUNTS_SUCCESS';
export const GET_RATED_INCREMENT_STEP = 'get_rated_incredment_step';
export const GET_RATED_DECREMENT_STEP = 'get_rated_decrement_step';
export const GET_RATED_RESET_STEPS = 'get_rated_reset_steps';
export const USER_SELECTED_PROFILE = 'user_selected_profile';

export const fetchPaidHitClub = (clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await getClub(mainApi, clubId);
        dispatch({
            type: FETCH_PAID_HIT_CLUB_SUCCESS,
            payload: res.data,
        });
    } catch {
        // non-critical: UI falls back gracefully
    }
};

export const fetchPaidHitClubPaymentAccounts = (clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await getClubPaymentAccounts(mainApi, clubId);
        dispatch({
            type: FETCH_PAID_HIT_CLUB_PAYMENT_ACCOUNTS_SUCCESS,
            payload: res.data,
        });
        return res.data;
    } catch {
        return null;
    }
};

export const saveOnboardingStep1 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: SAVE_ONBOARDING_STEP,
    });
    try {
        const res = await mainApi.post('v1/account/segment', {
            segment: data,
        });
        dispatch({
            type: SAVE_ONBOARDING_SUCCESS,
            payload: res,
        });
    } catch (err) {
        const errText = err.response ? err.response.data : 'Error communicating with server';
        dispatch({
            type: SAVE_ONBOARDING_FAILED,
            message: errText,
        });
        dispatch(showErrorPopup({
            message: 'Error saving',
            error: errText,
        }));
    }
};

const getPaidHitClub = (user) => async (dispatch) => {
    const paidHitClub = userIsPaidHitter(user);
    if (paidHitClub?.clubId) {
        dispatch(fetchPaidHitClub(paidHitClub.clubId));
        dispatch(fetchPaidHitClubPaymentAccounts(paidHitClub.clubId));
    }
};

export const signInFacebook = (token, registrationCampaign) => async (dispatch) => {
    dispatch({
        type: AUTHENTICATING_USER,
    });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Logging you in...',
    });
    try {
        const axiosInstance = getProxyAxiosInstance();
        const res = await axiosInstance.post('v1/auth/facebook', {
            accessToken: token,
            registrationCampaign,
        });
        dispatch(getPaidHitClub(res?.data));
        dispatch(getActiveLeagueTeams());
        dispatch({
            type: FETCH_AUTHENTICATED_USER,
            payload: res,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch (err) {
        const errText = getApiErrorMessage(err, 'Unable to authenticate');
        dispatch({
            type: AUTHENTICATION_FAILED,
            message: errText,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    }
};

export const signInGoogle = (code) => async (dispatch) => {
    dispatch({
        type: AUTHENTICATING_USER,
    });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Logging you in...',
    });
    try {
        const axiosInstance = getProxyAxiosInstance();
        const res = await axiosInstance.post('v1/auth/google', {
            code,
        });
        dispatch(getPaidHitClub(res?.data));
        dispatch(getActiveLeagueTeams());
        dispatch({
            type: FETCH_AUTHENTICATED_USER,
            payload: res,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch (err) {
        const errText = getApiErrorMessage(err, 'Unable to authenticate');
        dispatch({
            type: AUTHENTICATION_FAILED,
            message: errText,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    }
};

export const signInApple = (body) => async (dispatch) => {
    dispatch({
        type: AUTHENTICATING_USER,
    });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Logging you in...',
    });
    try {
        const axiosInstance = getProxyAxiosInstance();
        const res = await axiosInstance.post('v2/auth/apple', {
            ...body,
        });

        dispatch(getPaidHitClub(res?.data));
        dispatch(getActiveLeagueTeams());
        dispatch({
            type: FETCH_AUTHENTICATED_USER,
            payload: res,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch (err) {
        const errText = getApiErrorMessage(err, 'Unable to authenticate');
        dispatch({
            type: AUTHENTICATION_FAILED,
            message: errText,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    }
};

export const clearAuthError = () => ({ type: AUTH_CLEAR_ERROR });

export const signInEmail = (values) => async (dispatch) => {
    dispatch({
        type: AUTHENTICATING_USER,
    });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Logging you in...',
    });
    try {
        const axiosInstance = getProxyAxiosInstance();
        const res = await axiosInstance.post('v1/auth/login', {
            ...values,
        });

        const mfaToken = res?.data?.mfaToken;
        const userData = res?.data?.member ?? res?.data;

        if (mfaToken) {
            dispatch({ type: 'SET_MFA_TOKEN', payload: mfaToken });
        }
        dispatch(getPaidHitClub(userData));
        dispatch(getActiveLeagueTeams());
        dispatch({
            type: FETCH_AUTHENTICATED_USER,
            payload: { ...res, data: userData },
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch (err) {
        const errText = err.response?.data?.Message || 'Unable to authenticate';
        dispatch({
            type: AUTHENTICATION_FAILED,
            message: errText,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    }
};

export const impersonateMember = (memberEmailToImpersonate) => async (dispatch) => {
    dispatch({
        type: AUTHENTICATING_USER,
    });
    try {
        const axiosInstance = getProxyAxiosInstance();
        const res = await axiosInstance.post(`v1/auth/impersonate/${memberEmailToImpersonate}`, {
        });

        const userData = res?.data?.member ?? res?.data;
        dispatch(getPaidHitClub(userData));
        dispatch(getActiveLeagueTeams());
        dispatch({
            type: FETCH_AUTHENTICATED_USER,
            payload: { ...res, data: userData },
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Unable to impersonate',
            error: err,
        }));
    }
};

export const stopImpersonateMember = (memberEmailToImpersonate) => async (dispatch) => {
    try {
        const axiosInstance = getProxyAxiosInstance();
        await axiosInstance.post(`v1/auth/impersonate/${memberEmailToImpersonate}`, {
        });
    } catch (err) {
        const errText = err.response?.data?.Message || 'Unable to authenticate';
        dispatch({
            type: AUTHENTICATION_FAILED,
            message: errText,
        });
    }
};

export const validateMfaCode = (mfaCode) => async (dispatch, getState) => {
    try {
        const { mfaToken } = getState().auth;
        const axiosInstance = getProxyAxiosInstance();
        return await axiosInstance.post(`/v1/auth/2fa`, {
            oneTimePassword: mfaCode,
            mfaToken,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Invalid Code.',
            error: err,
        }));
        return err.response.Message;
    }
};

export const fetchServerAuthenticatedUser = () => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await mainApi.get('v1/auth/current');
        dispatch(getPaidHitClub(res?.data));
        dispatch(getActiveLeagueTeams());
        dispatch({
            type: FETCH_AUTHENTICATED_USER,
            payload: res,
        });
        return res;
    } catch (err) {
        const errText = err.response?.data?.Message || null;
        dispatch({
            type: AUTHENTICATION_FAILED_SILENT,
            message: errText,
        });
    }
};

export const fetchAuthenticatedUser = () => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await mainApi.get('v1/auth/current');
        dispatch(getPaidHitClub(res?.data));
        dispatch(getActiveLeagueTeams());
        dispatch({
            type: FETCH_AUTHENTICATED_USER,
            payload: res,
        });
        return res;
    } catch (err) {
        const errText = err.response?.data?.Message || 'Unable to authenticate';
        dispatch({
            type: AUTHENTICATION_FAILED,
            message: errText,
        });
        throw errText;
    }
};

export const updateMatchPlayAvailability = (value) => async (dispatch, getState, { mainApi }) => {
    const res = await mainApi.post('/v1/play/availability', value);
    const { data } = res;
    if (data.error) {
        throw Error;
    }
    return true;
};

export const updateEmailConfirmed = () => async (dispatch, getState) => {
    const { auth } = getState();
    auth.user.emailConfirmed = true;
    if (auth) {
        dispatch({
            type: CONFIRM_EMAIL_ACCEPTED,
            payload: auth.user,
        });
    }
};

export const USER_REGISTRATION_SUCCESS = 'user_registration_success';
export const saveRegistrationSuccess = (user) => (dispatch) => {
    dispatch({
        type: USER_REGISTRATION_SUCCESS,
        user,
    });
};

export const SAVE_USER_REGISTRATION = 'save_user_registration';
export const saveUserRegistration = (values) => async (dispatch, getState, { mainApi }) => {
    const { auth } = getState();
    if (auth) {
        values = {
            ...auth,
            ...values,
        };
    }
    const res = await saveRegistration(mainApi, values);
    dispatch(saveRegistrationSuccess(res.data));
};

export const USER_UPDATE_SUCCESS = 'user_update_success';
export const updateRegistrationSuccess = (user) => (dispatch) => {
    dispatch({
        type: USER_UPDATE_SUCCESS,
        user,
    });
};

export const UPDATE_USER_REGISTRATION = 'update_user_registration';
export const updateUserRegistration = (values) => async (dispatch, getState, { mainApi }) => {
    const res = await updateAccount(mainApi, values);
    dispatch(updateRegistrationSuccess(res.data));
};

export const updateUserMissingInfo = (values) => async (dispatch, getState, { mainApi }) => {
    const res = await updateMissingInfo(mainApi, values);
    dispatch(updateRegistrationSuccess(res.data));
};

export const SAVE_SURVEY_SUCCESS = 'save_survey_success';
export const saveSurveySuccess = (survey) => (dispatch) => {
    dispatch({
        type: SAVE_SURVEY_SUCCESS,
        survey,
    });
};

export const SAVE_USER_SURVEY = 'save_user_survey';
export const saveUserSurvey = (values) => async (dispatch, getState, { mainApi }) => {
    const { getRated, auth } = getState();
    const { user } = auth;
    if (user?.selfRateSurvey) {
        values.id = user.selfRateSurvey.id;
    } else {
        values.id = getRated?.survey?.id || null;
    }
    values.memberId = user?.id || null;
    const res = await saveSurvey(mainApi, values);
    dispatch(saveSurveySuccess(res.data));
};

export const CALCULATING_RATING = 'calculating_rating';
export const calculatingRating = isLoading => {
    return ({
        type: CALCULATING_RATING,
        isLoading,
    });
};

export const GET_RATED_SUCCESS = 'get_rated_success';
export const getRatedSuccess = (user) => async (dispatch) => {
    dispatch({
        type: GET_RATED_SUCCESS,
        user,
    });
    dispatch(calculatingRating(false));
};

export const SAVE_GET_RATED = 'save_get_rated';
export const saveGetRated = (values) => async (dispatch, getState, { mainApi }) => {
    dispatch(calculatingRating(true));
    const { getRated, auth } = getState();
    const { user } = auth;
    values.id = getRated.survey ? getRated.survey.id : null;
    values.memberId = user ? user.id : null;
    const res = await calculateRating(mainApi, values);
    dispatch(getRatedSuccess(res.data));
};

export const MYUTR_SELECT_SUCCESS = 'myutr_select_success';
export const myUtrSelectSuccess = (user) => async (dispatch) => {
    dispatch({
        type: MYUTR_SELECT_SUCCESS,
        user,
    });
};

export const SAVE_MYUTR_SELECT = 'save_myutr_select';
export const saveMyUtrSelect = (value) => async (dispatch, getState, { mainApi }) => {
    const res = await selectMyUtr(mainApi, value);
    dispatch(myUtrSelectSuccess(res.data));
};

export const CONFIRM_GET_RATED = 'confirm_get_rated';
export const confirmGetRated = (values) => async (dispatch, getState, { mainApi }) => {
    const { dashboard } = getState();
    const res = await confirmRating(mainApi, values);
    dispatch({
        type: CONFIRM_GET_RATED,
        payload: res,
    });
    if (dashboard?.profile) {
        dashboard.profile.myUtrSingles = res.data.claimedPlayer.myUtrSingles;
        dispatch({ type: 'DASHBOARD:UPDATE_CONFIRMED_RATING', data: { dashboard } });
    }
};

export const DISPOSE_OF_SURVEY = 'dispose_of_survey';
export const disposeOfSurvey = () => {
    return ({
        type: DISPOSE_OF_SURVEY,
    });
};

export const REGISTER_USER_ACCOUNT = 'register_user_account';
export const registerUserAccount = (values) => async () => {
    const axiosInstance = getProxyAxiosInstance();
    await registerAccount(axiosInstance, values);
};

export const submitContactForm = (values) => async (dispatch, getState, { mainApi }) => {
    await submitContact(mainApi, values);
};

export const VALIDATE_INVITE_SUCCESS = 'validate_invite_success';
export const validateInvite = (values) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });
        const res = await validateInviteToken(mainApi, values);
        dispatch({
            type: VALIDATE_INVITE_SUCCESS,
            payload: res,
        });
    } finally {
        dispatch({
            type: 'SPLASH_HIDE',
        });
    }
};

export const declineInvite = (values) => async (dispatch, getState, { mainApi }) => {
    const res = await declineInviteToken(mainApi, values);
    dispatch({
        type: 'INVITE:DECLINE_SUCCESS',
        payload: res,
    });
};

// set jwt token for all axios instances in WebViews
export function setAuthHeader({ jwt }) {
    return (dispatch, getState, axiosInstances) => {
        if (!jwt) {
            return;
        }

        const apis = Object.values(axiosInstances); // [mainApi, msgApi, leaguesApi, groupsApi, engageApi]
        apis.forEach(api => {
            api.defaults.headers.common.Authorization = `Bearer ${jwt}`;
        });
    };
}

export function setAuthUser({ id, isPowered }) {
    return (dispatch) => {
        if (id) {
            dispatch({
                type: FETCH_AUTHENTICATED_USER,
                payload: { data: { id, isPowered } },
            });
        }
    };
}

export const verifyUserMagicLink = (values) => async (dispatch) => {
    dispatch({
        type: AUTHENTICATING_USER,
    });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Logging you in...',
    });
    try {
        const axiosInstance = getProxyAxiosInstance();
        const res = await verifyMagicLink(axiosInstance, values);

        const mfaToken = res?.data?.mfaToken;
        const userData = res?.data?.member ?? res?.data;
        const callbackUrl = res?.data?.callbackUrl;

        if (mfaToken) {
            dispatch({ type: 'SET_MFA_TOKEN', payload: mfaToken });
        }

        if (callbackUrl) {
            dispatch({ type: AUTH_MAGIC_LINK_SET_CALLBACK_URL, payload: callbackUrl });
        }

        const paidHitClub = userIsPaidHitter(userData);
        if (paidHitClub?.clubId) {
            dispatch(fetchPaidHitClub(paidHitClub.clubId));
            dispatch(fetchPaidHitClubPaymentAccounts(paidHitClub.clubId));
        }
        dispatch(getActiveLeagueTeams());
        dispatch({
            type: FETCH_AUTHENTICATED_USER,
            payload: { ...res, data: userData },
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch (err) {
        const errText = err.response?.data?.Message || 'Unable to authenticate';
        dispatch({
            type: AUTHENTICATION_FAILED,
            message: errText,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    }
};
